import React from 'react'
import { Container, Typography } from '@mui/material'
import { createSearchParams, useNavigate, useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import styled from 'styled-components'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { useStatisticParams } from './useStatisticParams'

const StatisticEntityNameComponent = React.lazy(() => loadComponent('statistic', 'StatisticEntityName'))

const StyledTypography = styled(Typography)`
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 20px;
`

const EntityContainer = styled.span`
    cursor: pointer;
    display: flex;
    align-items: center;
`

export function StatisticEntityName() {
    const navigate = useNavigate()
    const { type, _id } = useParams()
    const [config, , getQueryParams] = useStatisticParams()

    const onContextSelect = (index: number) => {
        debugger

        const newContext = config.context!.slice(0, index + 1)
        const newEntity = newContext.pop()!
        const newParams = { ...config, breakdown: '', context: newContext }

        navigate({
            pathname: `/statistic/${newEntity.type}/${newEntity._id}`,
            search: `?${createSearchParams(getQueryParams(newParams))}`,
        })
    }

    return (
        <Container>
            <StyledTypography variant="h5" padding={2}>
                {config.context &&
                    config.context.map((c, index) => (
                        <>
                            <EntityContainer onClick={() => onContextSelect(index)}>
                                <StatisticEntityNameComponent type={c.type} _id={c._id} />
                            </EntityContainer>
                            <KeyboardArrowRightIcon fontSize="large" />
                        </>
                    ))}
                {type && _id && <StatisticEntityNameComponent type={type} _id={_id} />}
            </StyledTypography>
        </Container>
    )
}
